/** @jsxImportSource @emotion/react */
import { keyframes } from '@emotion/react';

const spin = keyframes`
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(360deg);
  }
`;

export const name = 'spinner';

export const Spinner = () => (
  <svg
    css={{ animation: `${spin} 3s infinite linear` }}
    viewBox="0 0 24 24"
    color="#161616"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5V2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12H20.5Z"
    />
  </svg>
);
